import React, { useEffect, useState } from "react";
import { useUser } from "../contexts/AuthContext";
import { jwtToken } from "../crud/axios";
import { CustomDrawer, CustomModal, NotificationBox } from "kh-design-system/components";
import "../components/Modal/Modal.css";
import Authentication from "../components/Authentication/Authentication";
import { useEvent } from "../contexts/EventContext";
import { useScreenWidth } from "../reusable/common";
import { galleryAccess } from "../utils/constants";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const { eventDetails } = useEvent();
	const isMobileScreen = useScreenWidth();
	const { user, isRegistered, loading } = useUser();
	const [drawerOpen, setDrawerOpen] = useState(false);
	const [isError, setIsError] = useState(false);
	const [toasterMessage, setToasterMessage] = useState("");
	const [notificationPopup, setNotificationPopup] = useState(false);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	useEffect(() => {
		if (
			eventDetails?.gallery_access === galleryAccess.PRIVATE &&
			!user &&
			!loading &&
			!jwtToken
		) {
			setDrawerOpen(true);
			setEmail("");
			setPassword("");
		} else if (
			eventDetails?.gallery_access === galleryAccess.PRIVATE &&
			user &&
			!isRegistered &&
			!loading &&
			jwtToken
		) {
			setDrawerOpen(true);
			setEmail("");
			setPassword("");
		} else if (
			eventDetails?.gallery_access === galleryAccess.PRIVATE &&
			user &&
			isRegistered &&
			!loading &&
			jwtToken
		) {
			setDrawerOpen(false);
		}
	}, [user, loading, jwtToken, eventDetails?.gallery_access]);

	useEffect(() => {
		if (notificationPopup) {
			const timer = setTimeout(() => {
				setIsError(false);
				setNotificationPopup(false);
			}, 3000);
			return () => clearTimeout(timer);
		}
	}, [notificationPopup]);

	useEffect(() => {
		if (drawerOpen) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "";
		}

		return () => {
			document.body.style.overflow = "";
		};
	}, [drawerOpen]);

	return (
		<>
			{(eventDetails?.gallery_access === galleryAccess.PRIVATE && !user && !jwtToken) ||
			(eventDetails?.gallery_access === galleryAccess.PRIVATE &&
				!isRegistered &&
				user &&
				jwtToken) ? (
				<>
					{isMobileScreen && drawerOpen && (
						<CustomDrawer
							open={drawerOpen}
							onOpen={() => {}}
							onClose={() => {}}
							onTouchStart={(event: any) => {
								event.nativeEvent.defaultMuiPrevented = true;
							}}
							maxHeight="100vh"
							minHeight="100vh"
							showSwipeIndicatorMobile={false}
							component={
								<div className="mt-4">
									<Authentication
										setIsError={setIsError}
										isError={isError}
										setToasterMessage={setToasterMessage}
										toasterMessage={toasterMessage}
										setNotificationPopup={setNotificationPopup}
										notificationPopup={notificationPopup}
										email={email}
										password={password}
									/>
								</div>
							}
						/>
					)}

					{notificationPopup && (
						<NotificationBox message={toasterMessage} isError={isError} />
					)}

					{!isMobileScreen && drawerOpen && (
						<CustomModal
							maxWidth="450px"
							openCustomModal={drawerOpen}
							onClose={() => {}}
							component={
								<div className="mt-4">
									<Authentication
										setIsError={setIsError}
										isError={isError}
										setToasterMessage={setToasterMessage}
										toasterMessage={toasterMessage}
										setNotificationPopup={setNotificationPopup}
										notificationPopup={notificationPopup}
										email={email}
										password={password}
									/>
								</div>
							}
						/>
					)}
				</>
			) : null}
			<div key={drawerOpen ? "hidden" : "visible"}>{children}</div>
			<style>
				{`
						.main-container {
							overflow-y: ${drawerOpen ? "hidden" : "auto"}
						}
					`}
			</style>
		</>
	);
};

export default ProtectedRoute;
